import React from 'react'
import { Col, FormControl } from 'react-bootstrap'

import styles from './styles/questionnaire.scss'

export function Wopi360OpenQuestion(props) {
  const { question, value, onChange, questionTitle, questionDescription } = props

  const maxChars = 800
  const remainingCharAmount = value ? maxChars - value.length : maxChars

  return (
    <Col md={6}>
      <h3>{questionTitle}</h3>
      <p>{questionDescription}</p>

      <FormControl
        componentClass="textarea"
        onChange={onChange(question.id)}
        value={value}
        rows="8"
        maxLength={maxChars}
        id={questionTitle.toLowerCase()}
      />
      <p className={styles.characterLimitText}>{`${remainingCharAmount} / ${maxChars}`}</p>
    </Col>
  )
}



// WEBPACK FOOTER //
// ./src/components/Wopi360OpenQuestion.js